import { Collapse } from "@mui/material";
import { Column } from "src/api/types";
import DataTable from "src/components/DataTable";
import Spinner from "src/components/Spinner";

interface Props<T> {
  onCollapse: boolean;
  data: T[];
  loading?: boolean;
  columns: Column<T>[];
  primaryKey: keyof T;
}

function DataCollapse<T>({
  onCollapse,
  data,
  loading,
  columns,
  primaryKey,
}: Props<T>) {
  return (
    <Collapse
      in={onCollapse}
      timeout="auto"
      unmountOnExit
      sx={{ width: "100%" }}
    >
      {loading ? (
        <Spinner />
      ) : (
        <DataTable
          data={data}
          height="100%"
          columns={columns}
          colorful
          primaryKey={primaryKey}
        />
      )}
    </Collapse>
  );
}

export default DataCollapse;
